var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "693px",
    height: "693px",
    viewBox: "0 0 693 693",
    enableBackground: "new 0 0 693 693",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 693,
    height: 693,
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,0) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,21) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,42) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,63) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,63) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,63) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,63) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,63) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,63) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,84) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,84) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,84) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,84) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,84) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,105) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,126) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,147) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,168) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,189) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,210) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,231) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,252) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,273) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,294) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,315) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,336) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,357) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,378) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,399) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,420) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,441) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,462) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,483) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,504) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,525) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588,546) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,567) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,588) scale(0.042,0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(1.47, 1.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M65.859,15.008H34.141c-4.082,0-7.869,1.258-10.979,3.398c-2.419,1.665-4.428,3.864-5.848,6.421 C15.838,27.484,15,30.526,15,33.758v32.471c0,10.344,8.586,18.76,19.145,18.76L50,84.992l15.855-0.004 C76.414,84.988,85,76.572,85,66.229V33.758C85,23.419,76.414,15.008,65.859,15.008z"
  }), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M65.859,0.008H34.141h0C18.683,0.008,5.587,10.221,1.4,24.18c-0.433,1.444-0.771,2.928-1.006,4.445 C0.135,30.299,0,32.013,0,33.758v32.471c0,18.619,15.32,33.76,34.141,33.76L50,99.992l15.859-0.004 c18.82,0,34.141-15.141,34.141-33.76V33.758C100,15.148,84.68,0.008,65.859,0.008z M85,66.229c0,10.344-8.586,18.76-19.145,18.76 L50,84.992l-15.855-0.004C23.586,84.988,15,76.572,15,66.229V33.758c0-3.231,0.838-6.273,2.313-8.931 c1.42-2.557,3.429-4.756,5.848-6.421c3.11-2.141,6.897-3.398,10.979-3.398h31.719C76.414,15.008,85,23.419,85,33.758V66.229z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462,0) scale(1.47, 1.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M65.859,15.008H34.141c-4.082,0-7.869,1.258-10.979,3.398c-2.419,1.665-4.428,3.864-5.848,6.421 C15.838,27.484,15,30.526,15,33.758v32.471c0,10.344,8.586,18.76,19.145,18.76L50,84.992l15.855-0.004 C76.414,84.988,85,76.572,85,66.229V33.758C85,23.419,76.414,15.008,65.859,15.008z"
  }), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M65.859,0.008H34.141h0C18.683,0.008,5.587,10.221,1.4,24.18c-0.433,1.444-0.771,2.928-1.006,4.445 C0.135,30.299,0,32.013,0,33.758v32.471c0,18.619,15.32,33.76,34.141,33.76L50,99.992l15.859-0.004 c18.82,0,34.141-15.141,34.141-33.76V33.758C100,15.148,84.68,0.008,65.859,0.008z M85,66.229c0,10.344-8.586,18.76-19.145,18.76 L50,84.992l-15.855-0.004C23.586,84.988,15,76.572,15,66.229V33.758c0-3.231,0.838-6.273,2.313-8.931 c1.42-2.557,3.429-4.756,5.848-6.421c3.11-2.141,6.897-3.398,10.979-3.398h31.719C76.414,15.008,85,23.419,85,33.758V66.229z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,462) scale(1.47, 1.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M65.859,15.008H34.141c-4.082,0-7.869,1.258-10.979,3.398c-2.419,1.665-4.428,3.864-5.848,6.421 C15.838,27.484,15,30.526,15,33.758v32.471c0,10.344,8.586,18.76,19.145,18.76L50,84.992l15.855-0.004 C76.414,84.988,85,76.572,85,66.229V33.758C85,23.419,76.414,15.008,65.859,15.008z"
  }), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M65.859,0.008H34.141h0C18.683,0.008,5.587,10.221,1.4,24.18c-0.433,1.444-0.771,2.928-1.006,4.445 C0.135,30.299,0,32.013,0,33.758v32.471c0,18.619,15.32,33.76,34.141,33.76L50,99.992l15.859-0.004 c18.82,0,34.141-15.141,34.141-33.76V33.758C100,15.148,84.68,0.008,65.859,0.008z M85,66.229c0,10.344-8.586,18.76-19.145,18.76 L50,84.992l-15.855-0.004C23.586,84.988,15,76.572,15,66.229V33.758c0-3.231,0.838-6.273,2.313-8.931 c1.42-2.557,3.429-4.756,5.848-6.421c3.11-2.141,6.897-3.398,10.979-3.398h31.719C76.414,15.008,85,23.419,85,33.758V66.229z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,42) scale(0.63, 0.63)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.351,100c-15.09,0-27.365-12.032-27.365-26.808V26.794c0-4.616,1.2-8.96,3.301-12.761 c2.029-3.658,4.901-6.802,8.36-9.174C16.09,1.801,21.506,0,27.336,0h45.327c15.076,0,27.351,12.018,27.351,26.793v46.398 c0,14.775-12.274,26.808-27.351,26.808H50H27.351z"
  })), /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,42) scale(0.63, 0.63)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.351,100c-15.09,0-27.365-12.032-27.365-26.808V26.794c0-4.616,1.2-8.96,3.301-12.761 c2.029-3.658,4.901-6.802,8.36-9.174C16.09,1.801,21.506,0,27.336,0h45.327c15.076,0,27.351,12.018,27.351,26.793v46.398 c0,14.775-12.274,26.808-27.351,26.808H50H27.351z"
  })), /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42,504) scale(0.63, 0.63)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.351,100c-15.09,0-27.365-12.032-27.365-26.808V26.794c0-4.616,1.2-8.96,3.301-12.761 c2.029-3.658,4.901-6.802,8.36-9.174C16.09,1.801,21.506,0,27.336,0h45.327c15.076,0,27.351,12.018,27.351,26.793v46.398 c0,14.775-12.274,26.808-27.351,26.808H50H27.351z"
  })), /*#__PURE__*/React.createElement("g", null))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.3a7737a5c1393fee95979cdd072940ee.svg";
export { ForwardRef as ReactComponent };